























































































































































import Vue from 'vue'
import Component from 'vue-class-component'
import ListView from '@/components/list/ListView.vue'
import { vxm } from '@/store'
import { formatDateTimeString } from '@/utils/dateUtils'
import { Prop } from 'vue-property-decorator'

@Component({
  methods: { formatDateTimeString },
  components: {
    ListView,
  },
})
export default class ExecuteConfiguration extends Vue {
  @Prop({ default: false }) readonly!: boolean
  @Prop({ required: true }) priceSetup!: any

  private showExecuteDialog = false

  private queuingNow = false
  private initialLoading = true

  private showConfigurationDialog = false
  private openedConfiguration = ''

  private stopQueueDialog = false
  private stopQueueLoading = false

  private executeHeaders = [
    { text: 'Queued at', value: 'queuedAt', sortable: true },
    { text: 'Queued by', value: 'queuedByUserFullName', sortable: true },
    { text: 'Executed at', value: 'executedAt', sortable: true },
    { text: 'Finished at', value: 'finishedAt', sortable: true },
    { text: 'Duration', value: 'duration', sortable: true },
    { text: 'Sites', value: 'executedForSites', sortable: true, align: 'right' },
    { text: 'Status', value: 'status', sortable: true },
    { text: 'Queued stopped by', value: 'queueStoppedByUserFullName', sortable: true },
    { text: 'Configuration', value: 'configuration', sortable: true },
  ]

  private executeHistoryUrl = '/v4/site/dackpartner/price-setup/executions'

  private sitesToExecute = []
  private sitesToExecuteWithAmount = []
  private sitesToExecuteWithPercent = []

  private created() {
    this.$axios
      .get('/v4/site/dackpartner/sites')
      .then((response) => {
        this.sitesToExecute = response.data.data.filter((item) => item.dackpartnerSubscribeSalesPrices === true)
        this.sitesToExecuteWithAmount = this.sitesToExecute.filter(
          (item) => item.dackpartnerSubscribeSalesPricesType === 'AMOUNT',
        )
        this.sitesToExecuteWithPercent = this.sitesToExecute.filter(
          (item) => item.dackpartnerSubscribeSalesPricesType === 'PERCENTAGE',
        )
      })
      .finally(() => {
        this.initialLoading = false
      })
  }

  private async queueCall(): Promise<void> {
    this.queuingNow = true
    try {
      await this.$axios.post('/v4/site/dackpartner/price-setup/queue', {
        siteIds: this.sitesToExecute.map((site) => site.id),
      })
      vxm.alert.success(this.$t('Price setup queue started successfully'))
      this.showExecuteDialog = false
      this.refreshExecutionsList()
      this.$emit('reload-configuration')
    } catch (err) {
      vxm.alert.onAxiosError(err, this.$t('Failed to queue price setup'))
    } finally {
      this.queuingNow = false
    }
  }

  private async stopQueue(): Promise<void> {
    this.stopQueueLoading = true
    try {
      await this.$axios.post('/v4/site/dackpartner/price-setup/stop-queue', {})
      vxm.alert.success(this.$t('Price setup queue stopped successfully'))
      this.stopQueueDialog = false
      this.refreshExecutionsList()
      this.$emit('reload-configuration')
    } catch (err) {
      vxm.alert.onAxiosError(err, this.$t('Failed to stop queue'))
    } finally {
      this.stopQueueLoading = false
    }
  }

  private openConfiguration(openedConfiguration) {
    this.openedConfiguration = JSON.stringify(JSON.parse(openedConfiguration), null, 2)
    this.showConfigurationDialog = true
  }

  private refreshExecutionsList(): void {
    if (this.$refs.executeHistoryList) {
      (this.$refs.executeHistoryList as any).load()
    }
  }
}
